<mat-tab-group id="tab-group" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="tabChanged($event)">

  <mat-tab label="{{'client.menu.credits_due' | translate | uppercase}}">
    <app-credits-due [selectedTabIndex]="selectedTabIndex" [savedDataBanco]="savedDataBanco" (changeTabEvent)="changeTab($event)" (changeTabstripeEvent)="changeTabStripe()" *ngIf="selectedTabIndex==0"></app-credits-due>
  </mat-tab>

  <mat-tab label="{{'client.menu.credits_history' | translate | uppercase}}">
    <app-credits-history [selectedTabIndex]="selectedTabIndex" *ngIf="selectedTabIndex==1" ></app-credits-history>
  </mat-tab>

</mat-tab-group>